import request from '@/plugin/axios'

/**
 * 查询空调列表
 * @param params
 * @returns {*}
 */
export function queryAcFeeDetailsAllByLimit(params) {
  return request({
    url: '/v1/electricity/acFeeDetails/queryAcFeeDetailsAllByLimit',
    method: 'get',
    params
  })
}

/**
 * 单户结算
 * @param data
 * @returns {*}
 */
export function airConditioningElectricityApportionment(data) {
  return request({
    url: '/v1/electricity/acFeeDetails/airConditioningElectricityApportionment',
    method: 'post',
    data
  })
}

/**
 * 批量结算
 * @param data
 * @returns {*}
 */
export function electricityApportionmentAccordingToConditions(data) {
  return request({
    url: '/v1/electricity/acFeeDetails/electricityApportionmentAccordingToConditions',
    method: 'post',
    data
  })
}

/**
 * 批量结算
 * @param data
 * @returns {*}
 */
export function batchSettlementIsVoid(data) {
  return request({
    url: '/v1/electricity/acFeeDetails/batchSettlementIsVoid',
    method: 'post',
    data
  })
}

/**
 * 查询指定空调房间在日期区间内的每月明细
 * @param params
 * @returns {*}
 */
export function queryAcFeeDetailsByAcUnitId(params) {
  return request({
    url: '/v1/electricity/acFeeDetails/queryAcFeeDetailsByAcUnitId',
    method: 'get',
    params
  })
}
